import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";
import { privateRequest } from "../../Components/commonApi/CommonApi";

import { Image_URL } from "../../Components/commonApi/CommonApi";
import { Helmet } from "react-helmet";
import axios from "axios";

function Inquiry() {
  const [Comment, setComment] = useState("");
  const [Inquiry, SetInquiry] = useState([]);
  const [inquiryId, setinquiryId] = useState([]);
  const [cityName, setCityName] = useState();
  const [citiesList, setCitiesList] = useState();

  const GetInquiry = async () => {
    try {
      const response = await privateRequest.get(`/Inquiry/Inquiry`);
      SetInquiry(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const GetCities = async () => {
    try {
      const response = await axios.get(
        `http://52.87.3.228:5500/api/v2/EnquiryCity/Enquiry`
      );
     
      setCitiesList(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const AddComment = async (event) => {
    try {
      const formData = {
        Comment: Comment,
      };

      await privateRequest.post(`Inquiry/Inquiry/${inquiryId}`, formData);

      GetInquiry();

      setComment("");

      // Show a success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Comment saved successfully!",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const AddCity = async (event) => {
    if (cityName.length == 0) {
      return;
    }

    try {
      const formData = {
        City: cityName,
        status: true,
      };

      await axios.post(
        `http://52.87.3.228:5500/api/v2/EnquiryCity/Enquiry`,
        formData
      );

      GetInquiry();

      // Show a success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Comment saved successfully!",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    GetInquiry();
    GetCities();
  }, []);

  console.log("citiesList", citiesList);

  return (
    <>
      {Inquiry.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Enquiries</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#addAreaModal2"
                      onClick={() => {
                        setCityName("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add City
                    </button>
                    <button
                      data-toggle="modal"
                      data-target="#addAreaModal3"
                      className="btn btn-primary btn-sm ml-auto"
                    >
                      <i className="fa fa-book mr-2"></i> View Cities
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">SN</th>

                            <th scope="col">Name</th>
                            <th scope="col">Phone No.</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Type</th>
                            <th scope="col">City </th>
                            <th scope="col">Category </th>

                            <th scope="col">Address </th>

                            <th scope="col">Message</th>
                            <th scope="col">comment</th>
                            <th scope="col">CreatedAt</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Inquiry?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">{item?.Name}</td>
                              <td className="align-center">{item?.PhoneNo}</td>
                              <td className="align-center">{item?.Email}</td>
                              <td className="align-center">{item?.Type}</td>
                              <td className="align-center">{item?.City}</td>
                              <td className="align-center">
                                {item?.PCName?.PCName}
                              </td>
                              <td className="align-center">{item?.Address}</td>
                              <td className="align-center">{item?.Message}</td>
                              <td className="align-center">
                                {item?.Comment?.length > 0 ? (
                                  <ul style={{ padding: 0, margin: 0 }}>
                                    {item.Comment.map((comment, idx) => (
                                      <li
                                        key={idx}
                                        style={{ listStyleType: "none" }}
                                      >
                                       {idx + 1}. {comment}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  "No comment"
                                )}
                              </td>

                              <td className="align-center">
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>

                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-warning btn-sm px-3"
                                    onClick={() => {
                                      setinquiryId(item._id);
                                    }}
                                    data-toggle="modal"
                                    data-target="#addAreaModal"
                                  >
                                    <i className="fa fa-comment mr-2"></i>
                                    <span className="d-none d-lg-inline-block">
                                      Add Comment
                                    </span>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addAreaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Add Inquiry
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddComment}>
                <div className="form-group">
                  <label className="mb-0">Write Inquiry</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Write Inquiry"
                    value={Comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>

                <div className="form-group text-left">
                  <button
                    onClick={() => {
                      AddComment();
                    }}
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="addAreaModal2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Add City Name
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddComment}>
                <div className="form-group">
                  <label className="mb-0"> City Name</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Write City"
                    value={cityName}
                    onChange={(e) => setCityName(e.target.value)}
                  />
                </div>

                <div className="form-group text-left">
                  <button
                    onClick={() => {
                      AddCity();
                    }}
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="addAreaModal3"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Cities
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>City</th>
                    <th>Status</th>
                    <th>Created At</th>
                  </tr>
                </thead>

                <tbody>
                  {citiesList?.map((item, index) => {
                    return (
                      <tr>
                        <td>{item?.City}</td>
                        <td>{item?.status == true ? "Active" : "Inactive"}</td>
                        <td>{item?.createdAt.slice(0, 10)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Inquiry;
